(function initBottomBanner() {
  var $window = $(window),
    $banner = $('.js-bottom-banner'),
    $wrapper = $('.site-wrapper'),
    bannerHeight = $banner.outerHeight(),
    scrollTop = 250;

  if ($banner.length) {
    checkBottomBannerPosition($banner, $wrapper, bannerHeight, scrollTop);

    $window.on('scroll', function() {
      checkBottomBannerPosition($banner, $wrapper, bannerHeight, scrollTop);
    });

    $window.on('resize', function() {
      bannerHeight = $banner.outerHeight();
      checkBottomBannerPosition($banner, $wrapper, bannerHeight, scrollTop);
    });
  }
})();

function checkBottomBannerPosition($banner, $wrapper, bannerHeight, scrollTop) {
  var $window = $(window);
  if ($window.scrollTop() >= scrollTop) {
    $banner.css('bottom', '0');
    $wrapper.css('padding-bottom', bannerHeight + 'px');
  }
  if ($window.scrollTop() < scrollTop) {
    $banner.css('bottom', - (bannerHeight + 20 ) + 'px');
    $wrapper.css('padding-bottom', '0');
  }
}
